import { format } from 'date-fns';
import { formatAgendaTime, toCalendarDate } from '../utils/calendarDateUtils';

export default function CalendarAgendaList({
  events = [],
  emptyMessage = 'Nothing scheduled.',
  onEventClick,
  showDate = false,
}) {
  if (events.length === 0) {
    return <p className="py-3 text-sm text-base-content/55">{emptyMessage}</p>;
  }

  return (
    <div className="min-w-0 divide-y divide-base-200">
      {events.map((event) => {
        const start = toCalendarDate(event.startDate);
        const content = (
          <>
            <span className="w-20 shrink-0 text-xs font-semibold text-base-content/55">
              {showDate && start ? format(start, 'EEE d MMM') : formatAgendaTime(event)}
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-medium">{event.title}</span>
              {showDate && (
                <span className="block text-xs text-base-content/55">{formatAgendaTime(event)}</span>
              )}
            </span>
          </>
        );
        const rowClass = 'flex w-full min-w-0 items-center gap-3 rounded py-2.5 text-left hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary';

        if (!onEventClick) {
          return <div key={event.id} className={rowClass}>{content}</div>;
        }

        return (
          <button
            key={event.id}
            type="button"
            className={rowClass}
            onClick={() => onEventClick(event)}
          >
            {content}
          </button>
        );
      })}
    </div>
  );
}
